import ReactGA from 'react-ga4';

// Initialize Google Analytics
export const initGA = (measurementId: string) => {
  // Only initialize in production
  if (process.env.NODE_ENV === 'production' && measurementId) {
    ReactGA.initialize(measurementId);
  }
};

// Track page views
export const logPageView = () => {
  if (process.env.NODE_ENV === 'production') {
    ReactGA.send({ hitType: 'pageview', page: window.location.pathname });
  }
};

// Track custom events
export const logEvent = (category: string, action: string, label?: string) => {
  if (process.env.NODE_ENV === 'production') {
    const eventParams: any = {
      category,
      action,
    };
    if (label) {
      eventParams.label = label;
    }
    ReactGA.event(eventParams);
  }
};

// Track button clicks
export const trackButtonClick = (buttonName: string) => {
  logEvent('User Interaction', 'Button Click', buttonName);
};

// Track section views
export const trackSectionView = (sectionName: string) => {
  logEvent('Navigation', 'Section View', sectionName);
};
